import React from 'react';
import { Alert, Button, MenuItem, TextField } from '@mui/material';
import { useAuth } from '@context/AuthContext';
import { useMyOrganizations } from '@hooks/useOrganization';
import { switchOrganization } from '../../utils/activeOrganization';

/** Hospital/branch picker for staff who work in more than one. Hidden otherwise. */
export const OrganizationSwitcher: React.FC = () => {
  const { user } = useAuth();
  const { data: orgs } = useMyOrganizations();
  if (!user || user.supportMode || (user.role as string) === 'superadmin') return null;
  const list: any[] = (orgs as any[]) ?? [];
  if (list.length < 2) return null;

  const current = user.organizationId || list.find((o) => o.isPrimary)?.id || list[0]?.id;
  return (
    <TextField
      select
      size="small"
      value={current ?? ''}
      onChange={(e) => {
        const org = list.find((o) => o.id === e.target.value);
        if (org) switchOrganization({ id: org.id, name: org.name });
      }}
      sx={{ minWidth: 180, display: { xs: 'none', sm: 'inline-flex' } }}
      SelectProps={{ inputProps: { 'aria-label': 'Hospital' } }}
    >
      {list.map((o) => (
        <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>
      ))}
    </TextField>
  );
};

/** Shown while a superadmin is looking at a hospital in read-only support view. */
export const SupportModeBanner: React.FC = () => {
  const { user } = useAuth();
  if (!user?.supportMode) return null;
  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={() => switchOrganization(null, '/superadmin/organizations')}>
          Exit support view
        </Button>
      }
    >
      Support view of <b>{user.organizationName}</b> — read-only. Every page you open is recorded in the hospital's audit log.
    </Alert>
  );
};
